import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-paper font-sans" data-id="element-189" data-mp="uyksaz99jqmd">
      <Header data-id="element-190" data-mp="uwgosifa0tmm" />
      <main className="flex-1" data-id="element-191" data-mp="78gz7ltpb99m">
        <Outlet data-id="element-192" data-mp="79s11g3l66y3" />
      </main>
      <Footer data-id="element-193" data-mp="7904o326056r" />
    </div>;
}